module.exports = __webpack_public_path__ + "img/mastercard-old.8372b944.svg";